/**
 * SIMODE API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface MovementMove { 
    DeviceId: string;
    Timestamp: string;
    SensorType: MovementMove.SensorTypeEnum;
    Event: MovementMove.EventEnum;
    Direction: number;
    Speed: number;
    EntryDirection: number;
    ExitDirection: number;
}
export namespace MovementMove {
    export const SensorTypeEnum = {
        G: 'G',
        T: 'T',
        P: 'P'
    } as const;
    export type SensorTypeEnum = typeof SensorTypeEnum[keyof typeof SensorTypeEnum];
    export const EventEnum = {
        NUMBER_0: 0
    } as const;
    export type EventEnum = typeof EventEnum[keyof typeof EventEnum];
}


